<template>
	<v-dialog v-model="showDialog" max-width="1000" persistent>
		<v-card>
			<v-card-title> Add Multiple Activity Items</v-card-title>
			<v-card-text>
				<v-form ref="form">
					<v-row no-gutters>
						<v-col>
							<v-menu
								v-model="startDateMenu"
								:close-on-content-click="false"
								:nudge-right="40"
								transition="scale-transition"
								offset-y
								min-width="auto"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										:value="
											getDateTimeFormat(
												activityItem.StartDate
											)
										"
										label="Start Date"
										prepend-icon="mdi-calendar"
										readonly
										v-bind="attrs"
										:rules="[
											(value) =>
												!!value ||
												'Start Date is required',
										]"
										v-on="on"
										hide-details
									></v-text-field>
								</template>
								<v-date-picker
									v-model="activityItem.StartDate"
									@input="startDateMenu = false"
									no-title
									color="green"
								></v-date-picker>
							</v-menu>
						</v-col>
						<v-col>
							<v-menu
								v-model="endDateMenu"
								:close-on-content-click="false"
								:nudge-right="40"
								transition="scale-transition"
								offset-y
								min-width="auto"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										:value="
											getDateTimeFormat(
												activityItem.EndDate
											)
										"
										label="End Date"
										prepend-icon="mdi-calendar"
										readonly
										v-bind="attrs"
										v-on="on"
										:rules="[
											(value) =>
												!!value ||
												'End Date is required',
										]"
										hide-details
									></v-text-field>
								</template>
								<v-date-picker
									v-model="activityItem.EndDate"
									@input="endDateMenu = false"
									no-title
									color="green"
								></v-date-picker>
							</v-menu>
						</v-col>
					</v-row>
				</v-form>
				<v-row
					no-gutters
					v-for="(item, index) in staticFields"
					:key="index"
				>
					<v-col>
						<activity-item-static-field
							:field="item"
							:index="index"
							:activityItem="activityItem"
							@change="onActivityItemStaticFieldChanged"
						/>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-card>
							<v-text-field
								class="px-2"
								label="Search"
								v-model="search"
							></v-text-field>
							<v-data-table
								v-if="headers && headers.length > 0"
								:items="activityItemGroupByFieldsValues"
								:headers="headers"
								dense
								:search="search"
								hide-default-header
								@current-items="getFiltered"
							>
								<template #header>
									<thead class="v-data-table-header">
										<tr
											v-if="loading"
											class="v-data-table__progress"
										>
											<th
												:colspan="headers.length + 2"
												class="column"
											>
												<v-progress-linear
													indeterminate
												></v-progress-linear>
											</th>
										</tr>
										<tr v-else>
											<th style="width: 10px">
												<v-checkbox
													class="my-0"
													hide-details
													v-model="selectAll"
													@click="
														selectMethod(
															activityItemGroupByFieldsValues,
															true
														)
													"
												>
												</v-checkbox>
											</th>
											<th
												v-for="(
													item, index
												) in groupByList"
												:key="index"
												:colspan="
													item.GridViewFields.length
												"
											>
												<template>
													<span>
														{{ item.Label }}
													</span>
												</template>
											</th>
										</tr>
									</thead>
								</template>
								<template v-slot:item.SelectAll="{ item }">
									<v-checkbox
										style="width: 10px"
										class="my-0"
										hide-details
										:input-value="isRowSelected(item)"
										@click="selectMethod([item], false)"
									></v-checkbox>
								</template>
								<template v-slot:footer.prepend>
									<span
										v-if="
											selectedRows &&
											selectedRows.length > 0
										"
										>{{ selectedRows.length }} selected
										items</span
									>
								</template>
							</v-data-table>
						</v-card>
					</v-col>
				</v-row>
			</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-btn @click.stop="onClose">Close</v-btn>
				<v-spacer />
				<v-btn color="primary" @click.stop="onSave">Save</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import { ActivityItemModalActions } from '../../../../../store/actions';
import { ActivityItemModalGetters } from '../../../../../store/getters';
import { mapGetters } from 'vuex';
import gridViewFieldUtils from '../../../../../utils/gridViewFieldsUtils';
import ActivityItemStaticField from '../activityItemModalComponents/ActivityItemStaticField.vue';
import projectSettingsMixin from '../../../../../mixins/projectSettingsMixin';
import MessageDialog from '@/components/core/dialogs/messageDialog';
export default {
	name: 'ActivityAddBulkItemModal',
	data() {
		return {
			startDateMenu: false,
			endDateMenu: false,
			groupByCriteria: [],
			selectedFiltersValues: [],
			filteredItems: [],
			selectAll: false,
			selectedRows: [],
			itemsPerPage: 5,
			page: 1,
			search: '',
			loading: false,
		};
	},
	mixins: [projectSettingsMixin],
	components: { ActivityItemStaticField },
	watch: {
		filteredItems(newVal) {
			let areEqual = true;
			let arr1 = new Set(this.selectedRows.map(JSON.stringify));
			let arr2 = new Set(newVal.map(JSON.stringify));
			arr2.forEach((item) => {
				if (!arr1.has(item)) {
					return (areEqual = false);
				}
			});
			this.selectAll = areEqual;
		},
		selectedRows(newVal) {
			let areEqual = true;
			let arr1 = new Set(newVal.map(JSON.stringify));
			let arr2 = new Set(this.filteredItems.map(JSON.stringify));
			arr2.forEach((item) => {
				if (!arr1.has(item)) {
					return (areEqual = false);
				}
			});
			this.selectAll = areEqual;
		},
	},
	computed: {
		...mapGetters({
			staticFields: [ActivityItemModalGetters.STATIC_FIELDS],
			groupByList: [ActivityItemModalGetters.GROUP_BY_LIST],
			gridViewFieldIds: [ActivityItemModalGetters.GRID_VIEW_FIELDS_IDS],
			gridViewFields: [ActivityItemModalGetters.GRID_VIEW_FIELDS],
			activityItemGroupByFieldsValues: [
				ActivityItemModalGetters.GROUP_BY_CRITERIA_VALUES,
			],
		}),

		selectedFilters() {
			let result = [];
			this.selectedFiltersValues.forEach((x) => {
				if (x.Value != null) {
					let obj = {};
					obj[x.GridViewFieldId] = x.Value;
					result.push(obj);
				}
			});
			return result;
		},
		headers() {
			if (this.gridViewFields.length == 0) return [];
			let result = this.gridViewFields.map((x) => {
				return {
					text: x.Label,
					value: gridViewFieldUtils.getFieldName(x),
				};
			});
			result.splice(0, 0, { text: '', value: 'SelectAll' });
			return result;
		},
		totalItems() {
			return this.activityItemGroupByFieldsValues.length;
		},
	},
	props: {
		showDialog: Boolean,
		activityItem: Object,
	},
	methods: {
		getFiltered(e) {
			this.filteredItems = e;
		},
		selectMethod(rows, isFromHeader) {
			if (isFromHeader === true) {
				this.filteredItems.forEach((fi) => {
					let index = this.selectedRows.indexOf(fi);
					if (isFromHeader && this.selectAll) {
						if (index < 0) this.selectedRows.push(fi);
					} else if (isFromHeader && this.selectAll == false) {
						if (index >= 0) this.selectedRows.splice(index, 1);
					}
				});
			} else {
				rows.forEach((row) => {
					let index = this.selectedRows.indexOf(row);
					if (isFromHeader === false) {
						if (index >= 0) {
							this.selectedRows.splice(index, 1);
						} else {
							this.selectedRows.push(row);
						}
					}
				});
			}
		},
		isRowSelected(row) {
			if (!this.selectedRows) return false;
			if (!row) return false;
			let item = this.selectedRows.find((x) => x == row);
			if (item) return true;
			return false;
		},
		onClose() {
			this.$emit('close');
		},
		onSave() {
			this.activityItem.GroupByCriteria = this.groupByCriteria;
			this.activityItem.GroupByFieldValues = this.selectedRows;
			if (this.selectedRows.length > 0) {
				if (this.$refs.form.validate()) {
					this.$store
						.dispatch(
							ActivityItemModalActions.BULK_INSERT,
							this.activityItem
						)
						.then(() => {
							this.$emit('close');
						});
				}
			} else {
				MessageDialog({
					message:
						'Please select at least one group by criteria from the table',
				});
			}
		},
		onActivityItemStaticFieldChanged(param, index) {
			if (this.activityItem.StaticFields[index])
				this.activityItem.StaticFields[index] = param;
			else this.activityItem.StaticFields.push(param);
		},
		getListValue(list, item) {
			let result = [];
			list.GridViewFields.forEach((l) => {
				result.push(item[gridViewFieldUtils.getFieldName(l)]);
			});
			return result.join(',');
		},
	},
	destroyed() {
		this.$store.dispatch(ActivityItemModalActions.CLEAR);
	},
	mounted() {
		this.loading = true;
		this.activityItem.ActivityId = this.$route.params.id;
		this.$store
			.dispatch(ActivityItemModalActions.LOAD, {
				itemId: this.activityItem.Id,
				activityId: this.activityItem.ActivityId,
			})
			.then(() => {
				this.gridViewFieldIds.forEach((gvfId) => {
					this.selectedFiltersValues.push({
						GridViewFieldId: gvfId,
						Value: null,
					});
				});
				this.activityItemGroupByFieldsValues.forEach((x) => {
					let item = this.selectedFiltersValues.find(
						(y) =>
							y.GridViewFieldId ==
							x.ActivityGroupByConditionFieldGridViewFieldId
					);
					if (item) {
						let val = x.Value;
						if (val === 'null') val = null;
						item.Value = val;
					}
				});
				this.$store
					.dispatch(
						ActivityItemModalActions.LOAD_GROUP_BY_CRITERIA_VALUES,
						{
							activityId: this.activityItem.ActivityId,
							filters: this.selectedFilters,
						}
					)
					.then(() => {
						this.loading = false;
					});
			});
	},
};
</script>
<style scoped></style>
